import React from "react";
import {SupportTicketsTable} from "../components/support/SupportTicketsTable";
import {useNavigate} from "react-router";

export const SupportTickets: React.FC = () => {
    const navigate = useNavigate();
    return <SupportTicketsTable goBack={() => navigate("/support")}/>
};